import React from "react"

export default function Nav() {
    return (
        <div className="nav">
            <i className="fas fa-globe-americas"></i>
            <h3 className="nav--header">my travel journal.</h3>
        </div>
    )
}